export default __webpack_public_path__ + "static/media/1939.8fabecad.png";